import {skipToken} from '@reduxjs/toolkit/query';
import {isFeatureEnabled} from 'feature-flags';

import {useGetTenantContentLanguagesQuery} from '@dms/api/settings';
import {featureFlags} from '@dms/feature-flags';

const MIN_LANGUAGES_FOR_MULTILANGUAGE = 2;

export function useContentLanguages() {
  const isFeatureFlagOn = isFeatureEnabled(featureFlags.ADVERTISEMENT_MULTILANGUAGE_CONTENT);

  const {data, isLoading, isError} = useGetTenantContentLanguagesQuery(
    isFeatureFlagOn ? undefined : skipToken
  );

  const enabledLanguages = data?.enabledLanguages ?? [];
  const isMultilanguageActive =
    isFeatureFlagOn && enabledLanguages.length >= MIN_LANGUAGES_FOR_MULTILANGUAGE;

  return {
    enabledLanguages,
    isMultilanguageActive,
    isLoading,
    isError,
  };
}
